<ngx-spinner type="ball-atom"></ngx-spinner>
<div class="component-container">
  <div class="component-header">
    <h2>Compensation Multipliers</h2>
    <div class="button-group">
      <button mat-raised-button color="primary" (click)="onCompensationMultiplierCorrected()" *ngIf="rightItem && matchedItems && matchedItems.length > 0">
        <mat-icon>assignment_turned_in</mat-icon>
        Correct
      </button>
      <button mat-raised-button color="primary" (click)="onCreateCompensationMultiplier()">
        <mat-icon>add</mat-icon>
        Add Compensation Multiplier
      </button>
    </div>
  </div>
  <app-lookup-table
      [items]="compensationMultipliers()"
      [columns]="columns"
      [enableMatching]="true"
      (itemClick)="onItemSelected($event)"
      (editClick)="onEditCompensationMultiplier($event)"
      (deleteClick)="onDeleteCompensationMultiplier($event)"
      (itemSave)="onItemSave($event)"
      (itemAdd)="onItemAdd($event)"
      (readyToMatch)="onReadyToMatch($event)">
    </app-lookup-table>
</div>
